import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { urlAcs } from '../common';

@Injectable({
  providedIn: 'root'
})
export class AccessService {

  constructor(private http: HttpClient) { }

  getAccess(id: string) {
    return this.http.get(`${urlAcs}/get-all/${id}`);
  }

  updateModuleAccessForUser(data: any) {
    return this.http.post(`${urlAcs}/update`, data);
  }

  getModuls() {
    return this.http.get(`${urlAcs}/get-all-moduls`);
  }

  createModul(data: any){
    return this.http.post(`${urlAcs}/create`, data);
  }

  deleteOneModuleAccess(data: any){
    return this.http.post(`${urlAcs}/delete`, data);
  }

  getPermissionUser(data: any){
    return this.http.post(`${urlAcs}/get-permit-user`, data);
  }

  getFirstNameModulForPerson(id: string) {
    return this.http.get(`${urlAcs}/get-first-module/${id}`);
  }

}
